import React, { useState } from 'react';
import { connect } from 'react-redux';
import CardActualizacionMasiva from "../../../General/Excel/CardActualizacionMasiva";
import MiniSpinner from '../../../General/MiniSpinner';
import {
  base64ToArrayBufferXlsx,
  saveByteArrayXlsx,
  formatFile
} from '../../../../utilities/formatFile';
import {
  postCreacionMasivaPublicacionesApi,
  fetchExportarCategoriasApi,
  fetchExportarMarcasApi
} from '../../../../api/axios';
import { getFrontendFeatureFlag } from '../../../../utilities/frontendConfig';
import { isProductionRuntime } from '../../../../utilities/runtimeEnvironment';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const CreacionMasivaPublicaciones = ({ tipoUsuario }) => {
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState({
    marcas: false,
    categorias: false,
    postPublicaciones: false
  });
  const navigate = useNavigate();
  const defaultWizardVisibility = !isProductionRuntime();
  const showCreacionMasivaWizard = getFrontendFeatureFlag(
    ['publicaciones', 'showCreacionMasivaWizard'],
    defaultWizardVisibility
  );

  const isLoadingHandler = (name, state) => {
    setIsLoading(prevState => ({ ...prevState, [name]: state }));
  };

  const downloadXlsMarcas = () => {
    isLoadingHandler("marcas", true);

    const req = fetchExportarMarcasApi();
    req.then(res => {
      const excel = res?.excel ?? res?.excelBase64;
      if (excel) {
        let blob = base64ToArrayBufferXlsx(excel);
        saveByteArrayXlsx('Marcas.xlsx', blob);
      }
      toast.success(res.message ?? "Exportación exitosa");
    }).catch(err => {
      toast.warn(err.message ?? "No se pudo descargar");
    }).finally(() => {
      isLoadingHandler("marcas", false);;
    });
  };

  const downloadXlsCategorias = () => {
    isLoadingHandler("categorias", true);

    const req = fetchExportarCategoriasApi();
    req.then(res => {
      const excel = res?.excel ?? res?.excelBase64;
      if (excel) {
        let blob = base64ToArrayBufferXlsx(excel);
        saveByteArrayXlsx('Categorias SubFamilias.xlsx', blob)
      }
      toast.success(res.message ?? "Exportación exitosa");
    }).catch(err => {
      toast.warn(err.message ?? "No se pudo descargar");
    }).finally(() => {
      isLoadingHandler("categorias", false);
    });
  }

  const isValidUpdateExcel = () => {
    if (!file) {
      toast.warn('No ha seleccionado ningún archivo excel.');
      return false;
    }
    return true;
  }

    const exportExcel = async () => {
        isLoadingHandler("postPublicaciones", true);

        try {
            const excelBase64 = await formatFile(file, "xlsx");
            const res = await postCreacionMasivaPublicacionesApi({ file: excelBase64 });

            const data = res.data ?? {};
            const publicadas = data.publicacion ?? [];
            const errores = data.errors ?? [];
            if (publicadas.length > 0 && errores.length > 0) {
                toast.success(`${publicadas.length} publicación(es) creada(s) con éxito.`);
                publicadas.forEach(pub =>
                    toast.success(`Publicación creada: ${pub.idPublicacion}`)
                );
                errores.forEach(err =>
                    toast.warn(`${err.skuSeller}: ${err.errorMesage}`)
                );
            } else if (publicadas.length > 0 && errores.length === 0) {
                toast.success(`${publicadas.length} publicación(es) creadas con éxito.`);
                navigate("/publicaciones");
            } else if (publicadas.length === 0 && errores.length > 0) {
                toast.error(`Ninguna publicación se creó. (${errores.length} error(es))`);

                errores.forEach(err =>
                    toast.warn(`${err.skuSeller}: ${err.errorMesage}`)
                );
            } 

        } catch (err) {
            if (err.response?.data?.errores?.length) {
                err.response.data.errores.forEach(e => toast.warn(e));
            } else {
                toast.error("Las publicaciones no pudieron ser creadas.");
            }
        } finally {
            isLoadingHandler("postPublicaciones", false);
        }
    };

  return (
    <div className="container">
    {tipoUsuario !== 6 &&
      <div className="row justify-content-between align-items-center page-titles text-center text-md-start">

        <div className="col-12 mb-4">
          <div className="row mb-2 pb-2">

            <div className="col-12 col-md-auto align-self-center">
              <h4 className="text-themecolor color-rojo-megatone">Creación Masiva</h4>
            </div>

            <div className="col-12 p-0 ps-1 border-2 border-start d-inline-flex">
              <div className="row align-items-center">
                <p style={{ fontWeight: "600" }}>Presione el botón Formato Excel para descargar un excel con el formato correcto, luego completelo y vuelva a importarlo.</p>
              </div>
            </div>

          </div>
        </div>

        <div className="card p-4">
          {showCreacionMasivaWizard && (
            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-4 p-3 rounded-4 border border-danger-subtle bg-light">
              <div>
                <h5 className="mb-1 color-rojo-megatone">Nuevo wizard guiado</h5>
                <p className="mb-0 text-muted">
                  Si queres cargar un lote paso a paso, ya podes probar la alternativa guiada sin dejar de lado el Excel legacy.
                </p>
              </div>
              <div className="d-flex justify-content-lg-end">
                <Link to="/Publicaciones/CreacionMasivaWizard" className="btn btn-danger">
                  Probar wizard guiado
                </Link>
              </div>
            </div>
          )}

          <CardActualizacionMasiva
            title="Publicaciones"
            btnText="Crear Publicaciones"
            tipoExcel={4}
            additionalHeader={(
              <div className="col-auto">
                <div className="row my-md-0 my-sm-2">

                  <div className="col-12 col-sm-auto my-2 my-sm-0"> 
                    <button
                      onClick={downloadXlsMarcas}
                      className="btn btn-sm btn-green"
                      disabled={isLoading.marcas}
                    >
                      Descargar Marcas
                    </button>
                  </div>
                  <div className="col-auto" hidden={!isLoading.marcas}>
                    <MiniSpinner />
                  </div>
                  
                  <div className="col-12 col-sm-auto my-0 my-sm-0">
                    <button
                      onClick={downloadXlsCategorias}
                      className="btn btn-sm btn-green"
                      disabled={isLoading.categorias}
                    >
                      Descargar Categorías
                    </button>
                  </div>
                  <div className="col-auto" hidden={!isLoading.categorias}>
                    <MiniSpinner />
                  </div>

                </div>
              </div>
            )}
            isLoading={isLoading.postPublicaciones}
            updateFile={setFile}
            exportExcel={exportExcel}
            isValidUpdateExcel={isValidUpdateExcel}
            downloadName="Modelo Creación Masiva de Publicaciones"
          />
        </div>

      </div>
    }
    </div>
  )
};
CreacionMasivaPublicaciones.propTypes = {
    tipoUsuario: PropTypes.number
}

const mapStateToProps = (state) => ({
  tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps)(CreacionMasivaPublicaciones);
